enum ComponentType {
  ITEM = "ITEM",
  LIST = "LIST",
  ROUTE = "ROUTE",
  PAGE = "PAGE",
  SETTINGS = "SETTINGS",
  BEACON_SCANNER = "BEACON_SCANNER",
  KEYPAD = "KEYPAD"
}

export default ComponentType
